import React, { useState } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { API_BASE_URL } from '../../config';
import { getPlatformIcon } from '../../utils/platformIcons';
import { cn } from "../../lib/utils";

interface SocialAvatarProps {
  accountId: string;
  platform: string;
  name: string;
  avatarUrl?: string | null;
  className?: string;
  imgClassName?: string;
  iconClassName?: string;
}

const SocialAvatar: React.FC<SocialAvatarProps> = ({
  accountId,
  platform,
  name,
  avatarUrl,
  className,
  imgClassName,
  iconClassName
}) => {
  const [useRemote, setUseRemote] = useState(false);
  const [loadError, setLoadError] = useState(false);

  // Try local avatar first (cached in DB, always available), then remote as fallback
  const localAvatarUrl = `${API_BASE_URL}/social-accounts/${accountId}/avatar?token=${localStorage.getItem('token')}`;

  const handleError = () => {
    if (!useRemote) {
      // Local failed, try remote URL
      setUseRemote(true);
    } else {
      // Both failed, show icon fallback
      setLoadError(true);
    }
  };

  return (
    <Avatar className={cn("h-full w-full", className)}>
      {!loadError && (
        <AvatarImage
          src={useRemote ? (avatarUrl || undefined) : localAvatarUrl}
          alt={name}
          onError={handleError}
          className={imgClassName}
        />
      )}
      <AvatarFallback className="bg-muted border-none text-foreground">
        {getPlatformIcon(platform, iconClassName || 'h-4 w-4')}
      </AvatarFallback>
    </Avatar>
  );
};

export default SocialAvatar;
